export enum SubscriptionStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export interface ISubscription {
  id: string;
  subscriberId: string;
  subscriberType: string;
  subscriberTypeId: string;
  description: string;
  altDescription: string | null;
  status: SubscriptionStatus;
  effectiveDate: string;
  expirationDate: string;
  updatedDateUtc: string;
  type: number;
  isMain: boolean;
}
